import {
  legacy_createStore as createStore,
  applyMiddleware,
  combineReducers,
  compose,
} from 'redux';
import { thunk } from 'redux-thunk';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import sessionReducer from './reducers/session';
import authReducer from './reducers/auth';

// Combine reducers if you have multiple reducers
const rootReducer = combineReducers({
  auth: authReducer,
  session: sessionReducer,
});

/**
 * Configuration for Redux Persist.
 * @type {object}
 * @property {string} key - The key for persisted storage.
 * @property {object} storage - The storage engine (localStorage by default).
 * @property {string[]} whitelist - List of reducers to persist.
 * @property {boolean} debug - Enables debugging logs for persistence.
 */

// Redux Persist config
const persistConfig = {
  key: 'root',
  storage, // Default to localStorage
  whitelist: ['auth', 'session'],
  debug: false, // Enable debug for logging state persistence
};

// Persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Middleware array for Redux store.
const middleware = [thunk];

// Setup Redux DevTools
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
// Redux store configured with combined reducers and middleware.
const store = createStore(
  persistedReducer,
  composeEnhancers(applyMiddleware(...middleware))
);

// Create a persistor to manage rehydration
const persistor = persistStore(store);

export { store, persistor };
